"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportRetryAttempt = exports.showError = exports.getResolvedError = exports.withErrorHandler = void 0;
const host_modules_1 = require("@wix/sdk-runtime/host-modules");
const getFromHostErrorHandlerOrDefault = (fn) => (host) => {
    if (!host.getErrorHandler) {
        throw new Error('Error handler is not available. Make sure to include the error handler in the host.');
    }
    return fn(host.getErrorHandler());
};
const errorHandler = (0, host_modules_1.createHostModule)({
    withErrorHandler: getFromHostErrorHandlerOrDefault((e) => e.withErrorHandler),
    getResolvedError: getFromHostErrorHandlerOrDefault((e) => e.getResolvedError),
    showError: getFromHostErrorHandlerOrDefault((e) => e.showError),
    reportRetryAttempt: getFromHostErrorHandlerOrDefault((e) => e.reportRetryAttempt),
});
exports.withErrorHandler = errorHandler.withErrorHandler;
exports.getResolvedError = errorHandler.getResolvedError;
exports.showError = errorHandler.showError;
/** @internal */
exports.reportRetryAttempt = errorHandler.reportRetryAttempt;
